export const CSS_PER_BREAKPOINT_PRESET = 'evCssPerBreakpointPreset'
export const CLASSIC_PRESET = 'evClassicPreset'
